module.exports = __webpack_public_path__ + "img/puneet_gupta.a58c1f6f.png";